import { useTranslation } from "react-i18next";
import whySpecterArImg from "../../images/why-specter-ar.png";
import whySpecterEnImg from "../../images/why-specter-en.png";
import whySpecterArSmImg from "../../images/why-specter-ar-sm.png";
import whySpecterEnSmImg from "../../images/why-specter-en-sm.png";
import skyIcon from "../../images/icons/sky.svg";
import statisticsIcon from "../../images/icons/statistics.svg";
import restaurantIcon from "../../images/icons/restaurant.svg";
import scanIcon from "../../images/icons/scan.svg";
import starIcon from "../../images/icons/star.svg";

const WhySpecter = () => {
  const { t, i18n } = useTranslation();

  return (
    <section id="why-us" className="bg-white">
      <div className="container mx-auto py-24 flex flex-col-reverse lg:flex-row justify-center items-end gap-14 px-4">
        <div className="w-full lg:w-1/2 flex justify-center">
          <img
            src={i18n.language === "ar" ? whySpecterArImg : whySpecterEnImg}
            className="hidden lg:block"
            alt="Specter App"
          />
          <img
            src={i18n.language === "ar" ? whySpecterArSmImg : whySpecterEnSmImg}
            className="block lg:hidden"
            alt="Specter App"
          />
        </div>

        <div className="w-full lg:w-1/2">
          <div className="flex justify-center lg:justify-start">
            <p className="flex text-4xl lg:text-5xl font-bold text-nowrap">
              {t("whyChooseSpecter.title")}
              <span className="px-2 text-primaryDark">
                {t("common.specter")}
              </span>
              {t("common.questionMark")}
            </p>
          </div>

          <p className="text-grayDark font-medium text-center rtl:lg:text-right ltr:lg:text-left mt-8 mb-6">
            {t("whyChooseSpecter.description")}
          </p>

          <div className="font-medium text-grayDarkness flex items-center gap-2 mb-3">
            <img src={skyIcon} alt="Sky Icon" />
            <p>{t("whyChooseSpecter.features.secureStorage")}</p>
          </div>

          <div className="font-medium text-grayDarkness flex items-center gap-2 mb-3">
            <img src={statisticsIcon} alt="Statistics Icon" />
            <p>{t("whyChooseSpecter.features.trackExpenses")}</p>
          </div>

          <div className="font-medium text-grayDarkness flex items-center gap-2 mb-3">
            <img src={restaurantIcon} alt="Restaurant Icon" />
            <p>{t("whyChooseSpecter.features.restaurants")}</p>
          </div>

          <div className="font-medium text-grayDarkness flex items-center gap-2 mb-8">
            <img src={scanIcon} alt="Scan Icon" />
            <p>{t("whyChooseSpecter.features.multiSupport")}</p>
          </div>

          <div className="w-full flex items-center">
            <div className="w-1/3 flex flex-col items-center gap-1 mr-2 py-2">
              <div className="flex items-center gap-1">
                <p className="text-black text-base md:text-xl font-bold">
                  {t("app.reviewsValue")}
                </p>
                <img src={starIcon} alt="Reviews" />
              </div>
              <p className="text-grayDark text-sm md:text-base">
                {t("app.reviews")}
              </p>
            </div>

            <div className="w-1/3 flex flex-col items-center gap-1 mr-2 py-2 rtl:border-r ltr:border-l border-grayDark">
              <p className="text-black text-base md:text-xl font-bold">
                {t("app.downloadsValue")}
              </p>
              <p className="text-grayDark text-sm md:text-base">
                {t("app.downloads")}
              </p>
            </div>

            <div className="w-1/3 flex flex-col items-center gap-1 mr-2 py-2 rtl:border-r ltr:border-l border-grayDark">
              <p className="text-black text-base md:text-xl font-bold">
                {t("app.versionValue")}
              </p>
              <p className="text-grayDark text-sm md:text-base">
                {t("app.version")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySpecter;
